import React, { useState } from "react";
import { AddIcon, PasteIcon, EditIcon, CheckIcon, CloseIcon, DeleteIcon } from "../../common/icons";

export default function LocatiesSection({
    locaties = [],
    newLocationInput,
    copiedLocationsData,
    gebrekId,
    onLocationInputChange,
    onAddLocation,
    onCopyLocations,
    onPasteLocations,
    onEditLocation,      // (gebrekId, locatieId, newName) => void
    onDeleteLocation,    // (gebrekId, locatieId) => void
    disableCopy,
}) {
    const [editingId, setEditingId] = useState(null);
    const [editingValue, setEditingValue] = useState("");

    const startEdit = (locatie) => {
        setEditingId(locatie.locatieid);
        setEditingValue(locatie.locatienaam);
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditingValue("");
    };

    const saveEdit = (locatie) => {
        if (editingValue.trim() && editingValue !== locatie.locatienaam) {
            onEditLocation(gebrekId, locatie.locatieid, editingValue.trim());
        }
        setEditingId(null);
        setEditingValue("");
    };

    return (
        <div>
            <div className="flex justify-between items-center mb-1">
                <h3 className="text-sm font-semibold text-gray-700">Locatie(s):</h3>
                <div className="flex items-center space-x-2">
                    {copiedLocationsData &&
                        copiedLocationsData.sourceGebrekId !== gebrekId && (
                            <button
                                type="button"
                                onClick={() => onPasteLocations(gebrekId)}
                                className="px-2 py-0.5 bg-purple-100 text-purple-700 text-xs font-semibold rounded shadow-sm hover:bg-purple-200"
                                title={`Plak ${copiedLocationsData.locations.length} locatie(s)`}
                            >
                                <PasteIcon /> Plakken
                            </button>
                        )}
                    <button
                        type="button"
                        onClick={() => onCopyLocations(gebrekId, locaties)}
                        disabled={disableCopy || !locaties || locaties.length === 0}
                        className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-semibold rounded shadow-sm hover:bg-blue-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        title="Kopieer locaties om in ander gebrek te plakken"
                    >
                        Kopieer
                    </button>
                </div>
            </div>
            {/* Display existing locations */}
            <div className="flex flex-row flex-wrap gap-2 mb-2">
                {locaties?.length > 0 ? (
                    locaties.map((locatie) => (
                        <div key={locatie.locatieid} className="flex items-center gap-1">
                            {editingId === locatie.locatieid ? (
                                <>
                                    <input
                                        type="text"
                                        value={editingValue}
                                        onChange={(e) => setEditingValue(e.target.value)}
                                        className="p-2 border rounded-md shadow-sm text-sm"
                                        autoFocus
                                    />
                                    <button
                                        type="button"
                                        className="p-1 text-green-600 hover:bg-green-100 rounded"
                                        title="Opslaan"
                                        onClick={() => saveEdit(locatie)}
                                    >
                                        <CheckIcon />
                                    </button>
                                    <button
                                        type="button"
                                        className="p-1 text-gray-500 hover:bg-gray-200 rounded"
                                        title="Annuleren"
                                        onClick={cancelEdit}
                                    >
                                        <CloseIcon />
                                    </button>
                                </>
                            ) : (
                                <>
                                    <input
                                        type="text"
                                        value={locatie.locatienaam}
                                        disabled
                                        className="p-2 border rounded-md shadow-sm bg-gray-200 text-sm"
                                        title={`ID: ${locatie.locatieid}`}
                                    />
                                    <button
                                        type="button"
                                        className="p-1 text-blue-600 hover:bg-blue-100 rounded"
                                        title="Bewerk"
                                        onClick={() => startEdit(locatie)}
                                    >
                                        <EditIcon />
                                    </button>
                                    <button
                                        type="button"
                                        className="p-1 text-red-600 hover:bg-red-100 rounded"
                                        title="Verwijder"
                                        onClick={() => onDeleteLocation(gebrekId, locatie.locatieid)}
                                    >
                                        <DeleteIcon />
                                    </button>
                                </>
                            )}
                        </div>
                    ))
                ) : (
                    <p className="text-sm text-gray-500 italic">
                        Geen locaties toegevoegd.
                    </p>
                )}
            </div>
            {/* Add new location input */}
            <div className="flex items-center gap-2">
                <input
                    type="text"
                    value={newLocationInput || ""}
                    onChange={(e) => onLocationInputChange(gebrekId, e.target.value)}
                    placeholder="Nieuwe locatienaam"
                    className="p-2 border rounded-md shadow-sm focus:ring focus:ring-blue-300 flex-grow text-sm"
                />
                <button
                    type="button"
                    onClick={() => onAddLocation(gebrekId)}
                    className="px-3 py-1 bg-blue-500 text-white text-sm font-semibold rounded-md shadow-sm hover:bg-blue-600 whitespace-nowrap"
                >
                    <AddIcon /> Toevoegen
                </button>
            </div>
        </div>
    );
}
